/* globals Vivus */

$(() => {
  let direction = 1;
  const bganim = new Vivus('cairo-bg', {
    duration: 200,
    delay: 100,
    file: 'assets/img/cairo-white.svg',
    type: 'oneByOne',
    onReady: () => {
      bganim.play(direction);
      direction *= -1;
    },
  }, () => {
    bganim.stop();
    bganim.play(direction);
    direction *= -1;
  });
});
